






























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { firestore } from "@/scripts/firebase";
import { Message, JinroPlayerDocument } from "@/services/datatypes";
import PublicViewerPosterName from "./PublicViewerPosterName.vue";
import EmojiPicker from "@/components/shared/EmojiPicker.vue";

@Component({
  components: {
    PublicViewerPosterName,
    EmojiPicker,
  },
})
export default class HandlePostChat extends Vue {
  @Prop() readonly refChatroom!: firebase.firestore.CollectionReference;
  newMessage = "";
  posterTmpName = this.userName ? this.userName : "名無し";
  isShowingEmojiPicker = false;

  get isPublicViewing(): boolean {
    // public view path example:  /j/TAYBteCF9uJnFVyUtP8W/public
    const elmnts = this.$route.path.split("/");

    return elmnts.length > 3 && this.$route.path.split("/")[3] === "public";
  }

  selectEmoji(emoji: any) {
    document.execCommand("insertText", false, emoji);
    this.newMessage += emoji;
  }

  showEmojiPicker(): void {
    this.isShowingEmojiPicker = true;
  }
  closeEmojiPicker(): void {
    this.isShowingEmojiPicker = false;
  }

  get iconRight(): string {
    if (this.isFormBlank) {
      return "";
    }
    return "far fa-paper-plane";
  }

  get isFormBlank(): boolean {
    return this.newMessage === "";
  }

  get jinroPlayer(): JinroPlayerDocument | null {
    if (this.$store.state.jinroPlayer) {
      return this.$store.state.jinroPlayer;
    }

    return null;
  }

  async handlePost() {
    if (this.isFormBlank) {
      return;
    }
    const newMessage = this.newMessage;
    this.newMessage = "";
    let params = {};
    if (this.isPublicViewing) {
      params = this.getPublicViewerParams(newMessage);
    } else {
      params = this.getJinroPlayerParams(newMessage);
    }
    await this.refChatroom.add(params);
  }
  getJinroPlayerParams(newMessage: string) {
    const params = {
      playerId: this.$route.params.jinroPlayerId,
      playerName: this.jinroPlayer!.playerName,
      uid: this.jinroPlayer!.uid,
      timeCreated: firestore.FieldValue.serverTimestamp(),
      message: newMessage,
    };
    return params;
  }

  getPublicViewerParams(newMessage: string) {
    const params = {
      playerId: null,
      fromPublicViewing: true,
      playerName: this.posterName,
      uid: this.uid,
      timeCreated: firestore.FieldValue.serverTimestamp(),
      message: newMessage,
    };

    return params;
  }

  get posterName(): string {
    if (this.hasUser) {
      return this.userName;
    }

    return this.posterTmpName;
  }

  get hasUser(): boolean {
    return !!this.$store.state.firebaseUser;
  }

  get uid() {
    if (this.isPublicViewing || !this.jinroPlayer) {
      return this.userUid ? this.userUid : null;
    }
    return this.jinroPlayer.uid;
  }

  get userUid(): string | undefined {
    if (this.$store.state.firebaseUser) {
      return this.$store.state.firebaseUser.uid;
    }

    return undefined;
  }
  get userName(): string {
    if (this.$store.state.user) {
      return this.$store.state.user.displayName;
    }
    return "";
  }
}
